import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import ProductPhoneNumberGroup from 'src/app/display-model/product-phone-number-group';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Company from 'src/app/model/company/company';
import Product from 'src/app/model/product/product';
import { Project } from 'src/app/model/project/project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { ClientProductSummaryHelper } from '../helper/client-product-summary-helper';
import { FileHelper } from '../../../../../../../helpers/file-helper';

@Component({
  selector: 'client-non-ip-board-design-summary',
  templateUrl: './client-non-ip-board-design-summary.component.html',
  styleUrls: ['./client-non-ip-board-design-summary.component.scss'],
})
export class ClientNonIPBoardDesignSummaryComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  product: Product;
  @Input()
  project: Project;
  @Input()
  client: boolean = false;
  @Input()
  projectContactToCompanySubject: Subject<Map<number, Company>>;

  projectContactToCompany: Map<number, Company>;
  productPhoneNumberGroups: ProductPhoneNumberGroup[] = [];
  multiplePhoneNumbers: boolean = false;
  isImage = FileHelper.isImage;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.projectContactToCompanySubject,
      (map: Map<number, Company>) => {
        this.projectContactToCompany = map;
        this.calculateProductPhoneNumberGroups();
      }
    );

    this.addSubscription(
      this.projectDisplayObservableService.getProductPhoneNumberChangedSubscribable(),
      () => {
        this.calculateProductPhoneNumberGroups();
      }
    );
  }

  private calculateProductPhoneNumberGroups(): void {
    this.productPhoneNumberGroups =
      ClientProductSummaryHelper.getProductPhoneNumberGroups(
        this.product,
        this.project,
        this.projectContactToCompany,
        this.client
      );
    this.multiplePhoneNumbers =
      this.productPhoneNumberGroups.length > 1 ||
      this.productPhoneNumberGroups.some((g) => g.phoneNumbers.length > 1);
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
